import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import UserMonthlyChartSharedAxis from "./UserMonthlyChartSharedAxis";

const UserMonthlyUsageLogins = (props) => {
  const { userData, systemAverages } = props;
  const {
    // user,
    session,
    // profile
  } = userData;
  const [datasets, setDatasets] = useState([]);

  useEffect(() => {
    if (
      session &&
      session.monthlySummary &&
      Array.isArray(systemAverages) &&
      systemAverages.length > 0
    ) {
      var datasets = [];

      var datasetLogin = {
        type: "bar",
        label: "Login count",
        data: session.monthlySummary.map((value, index) => {
          return { x: moment(value.monthCode), y: value.totalSessions };
        }),
      };
      datasets.push(datasetLogin);

      var datasetAverage = {
        type: "line",
        label: "System Average",
        lineTension: 0.3,
        data: systemAverages.map((value, index) => {
          return {
            x: moment(value.monthCode),
            y: value.averageSessions,
          };
        }),
      };
      datasets.push(datasetAverage);

      setDatasets(datasets);
    }
  }, [session, systemAverages]);

  return (
    <React.Fragment>
      <UserMonthlyChartSharedAxis datasets={datasets} />
    </React.Fragment>
  );
};

export default UserMonthlyUsageLogins;
